import { useAccount } from "../../context/AccountContext";

/**
 * Whose apiary am I working in? (#310)
 *
 * Renders NOTHING for the ordinary solo keeper -- there is no choice to
 * make, and a control that always says "My apiary" is furniture.
 *
 * It appears the moment somebody is helping at another apiary, because
 * that is exactly when "which account does this belong to" stops being
 * obvious. It is deliberately a plain, always-visible control rather than
 * something tucked in a menu: the answer changes where every hive, site,
 * vendor and jar you create ends up, and it must be readable at a glance
 * before you start typing, not discoverable afterwards.
 */
export function AccountSwitcher() {
  const { accounts, actingAccountId, switchTo, hasChoice } = useAccount();

  if (!hasChoice) return null;

  const workingElsewhere = Boolean(actingAccountId);

  return (
    <label
      style={{
        display: "flex", alignItems: "center", gap: "var(--space-2)",
        // Coloured only when it is NOT your own apiary. A warning tone that
        // is always on stops being a warning.
        padding: "var(--space-1) var(--space-2)",
        borderRadius: "var(--radius-md)",
        border: `1px solid ${workingElsewhere ? "var(--color-warning)" : "var(--color-border)"}`,
        background: workingElsewhere ? "color-mix(in srgb, var(--color-warning) 12%, transparent)" : "transparent",
      }}
    >
      <span style={{ color: "var(--color-text-muted)", whiteSpace: "nowrap" }}>
        Working in
      </span>
      {/* id and name for the same reason as TopBar's language select.
          This one is already inside its own <label>, so it was labelled
          correctly -- but an implicit label is not an id, and Chrome
          flags the field regardless. */}
      <select
        id="acting-account-select"
        name="acting_account"
        aria-label="Which apiary you are working in"
        value={actingAccountId || ""}
        onChange={(e) => switchTo(e.target.value ? Number(e.target.value) : null)}
        className="touch-target"
      >
        <option value="">My apiary</option>
        {accounts.map((a) => (
          <option key={a.share_id} value={a.primary_user_id}>
            {a.primary_email}
          </option>
        ))}
      </select>
    </label>
  );
}
